import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import { globalizeSelectors } from '../Utils';
import {
  arrayDataType,
  createArrayDataReducer,
  createSingleDataReducer,
  singleDataType,
} from '../factories/ApiCall';
import type {
  ColorantInventoryItem,
  InventoryAction,
  InventoryResponse,
  InventoryState,
  ReportConsumptionPayload,
  UpdateInventoryPayload,
} from '../types/Inventory';

/*
 * action types
 */

const types = {
  FETCH: 'INVENTORY/FETCH',
  UPDATE: 'INVENTORY/UPDATE',
  REPORT: 'INVENTORY/REPORT',
} as const;

const mountPath = 'inventory'; // mount point in global state, must match root reducer

/*
 * action creators
 */

const actions = {
  fetchInventory: (): InventoryAction<Record<string, never>> => ({
    type: types.FETCH,
    payload: {},
  }),
  updateInventory: (
    data: UpdateInventoryPayload
  ): InventoryAction<UpdateInventoryPayload> => ({
    type: types.UPDATE,
    payload: data,
  }),
  reportConsumption: (
    data: ReportConsumptionPayload
  ): InventoryAction<ReportConsumptionPayload> => ({
    type: types.REPORT,
    payload: data,
  }),
};

/*
 * state shape
 */
const propType = PropTypes.shape({
  colorants: arrayDataType,
  update: singleDataType,
  report: singleDataType,
});

/*
 * reducer
 */
const reducer = combineReducers({
  colorants: createArrayDataReducer<
    ColorantInventoryItem,
    Record<string, never>
  >(types.FETCH),
  update: createSingleDataReducer<InventoryResponse, UpdateInventoryPayload>(
    types.UPDATE
  ),
  report: createSingleDataReducer<InventoryResponse, UpdateInventoryPayload>(
    types.UPDATE
  ),
}) as (
  state: InventoryState | undefined,
  action: InventoryAction
) => InventoryState;

/*
 * selectors
 */
const localSelectors = {
  colorants: (state: InventoryState): InventoryState['colorants'] =>
    state.colorants,
  update: (state: InventoryState): InventoryState['update'] => state.update,
  report: (state: InventoryState): InventoryState['report'] => state.report,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export {
  types as actionTypes,
  actions as default,
  propType,
  selectors,
  reducer,
};
